import { render, staticRenderFns } from "./V2RelatedProductCard.vue?vue&type=template&id=f7ac9ed2&scoped=true&"
import script from "./V2RelatedProductCard.vue?vue&type=script&lang=js&"
export * from "./V2RelatedProductCard.vue?vue&type=script&lang=js&"
import style0 from "./V2RelatedProductCard.vue?vue&type=style&index=0&id=f7ac9ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ac9ed2",
  null
  
)

export default component.exports